import { render, staticRenderFns } from "./VotesGeneratorPage.vue?vue&type=template&id=3f0354e2"
import script from "./VotesGeneratorPage.vue?vue&type=script&lang=ts"
export * from "./VotesGeneratorPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports